
import store from "@/store"
import organisations from "@/store/modules/assessment/Organisations.js";
import groups from "@/store/modules/assessment/Groups.js";
import users from "@/store/modules/assessment/Users.js";
import surveys from "@/store/modules/assessment/Surveys.js";
import assessments from "@/store/modules/assessment/Assessments.js";
import assessmentSettings from "@/store/modules/assessment/AssessmentSettings.js";
import collaborations from "@/store/modules/assessment/Collaborations.js";


const modules = {
    "assessments": assessments,
    "assessmentSettings": assessmentSettings,
    "organisations": organisations,
    "users": users,
    "surveys": surveys,
    "groups": groups,
    "collaborations": collaborations
}

const actions = {
  registerModules(){
    Object.keys(modules).forEach( m => {
      if( !store.hasModule(m) ){
        store.registerModule(m, modules[m]);
      }
    })
    //TODO - This sets the current logged in user as the lead for the dummy data. DUMMY ONLY
    store.commit("assessments/SET_LEAD")
  },
  unregisterModules(){
    modules.forEach( m => {
      if( store.hasModule(m) ){
        store.unregisterModule(m)
      }
    })
  },
} 

export default {
  actions,
};
